export const parseNestedJson = (json: string) => {
  let parsedJson = JSON.parse(json);
  if (typeof parsedJson === 'string') {
    parsedJson = JSON.parse(parsedJson);
  }
  
  if (typeof parsedJson === 'string')
    throw new Error('Invalid JSON');

  return parsedJson;
};